import { render } from "./CommentsCard.vue?vue&type=template&id=382d5c34&scoped=true"
import script from "./CommentsCard.vue?vue&type=script&lang=js"
export * from "./CommentsCard.vue?vue&type=script&lang=js"

import "./CommentsCard.vue?vue&type=style&index=0&id=382d5c34&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-382d5c34"

export default script